function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveRadioBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 7.42857,
    stroke: "#3AB67D",
    style: {
      stroke: "#3AB67D",
      stroke: "color(display-p3 0.2275 0.7137 0.4902)",
      strokeOpacity: 1
    },
    strokeWidth: 1.14286
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.00112,
    cy: 8.50112,
    r: 4.57143,
    fill: "#3AB67D",
    style: {
      fill: "#3AB67D",
      fill: "color(display-p3 0.2275 0.7137 0.4902)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRadioBtn);
export default __webpack_public_path__ + "static/media/activeRadioBtn.3ccf4e7dac5e7d1bcb50364defdd09a3.svg";
export { ForwardRef as ReactComponent };